<!-- <div class="row" style="border-style: solid;border-color: rgb(43, 156, 226);">
    <div class="col-md-6 offset-md-3 mt-5 flexBox" style="border-style: solid;border-color: blueviolet;display: flex;justify-content: center;flex-flow: row wrap;">

    </div>
</div> -->
<div class="row">
    <div class="flexBox" style="
      display: flex;
      flex-flow: row wrap;
      justify-content: center;">
              <div class="card ">
                <h4 class="card-header text-center">Login</h4>
                <div class="card-body">
                    <form [formGroup]="loginForm" (ngSubmit)="onSubmit()">
                        <div class="form-group">
                            <label for="username">Username</label>
                            <input type="text" formControlName="username" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.username.errors }" />
                            <div *ngIf="submitted && f.username.errors" class="invalid-feedback">
                                <div *ngIf="f.username.errors.required">Username is required</div>
                            </div>
                        </div>
                        <div class="form-group">
                            <label for="password">Password</label>
                            <input type="password" formControlName="password" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.password.errors }" />
                            <div *ngIf="submitted && f.password.errors" class="invalid-feedback">
                                <div *ngIf="f.password.errors.required">Password is required</div>
                            </div>
                        </div>
                        <div class=" text-center">
                            <button  class="btn " style="background-color: #4c3180;color: azure;">
                                Login
                            </button>
                        </div>
                        <div *ngIf="error" class="alert alert-danger mt-3 mb-0">{{error}}</div>
                    </form>
                </div>
            </div>
    </div>
  </div>